/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MasterclassInputs */

const en_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masterclass`)
};

const es_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clase magistral`)
};

const fr_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masterclass`)
};

const de_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masterclass`)
};

const ja_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マスタークラス`)
};

const zh_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大师班`)
};

const ar_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درس متقدم (Masterclass)`)
};

const id_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelas Master`)
};

const it_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masterclass`)
};

const ru_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мастер-класс`)
};

const pt_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masterclass`)
};

const ko_val_masterclass = /** @type {(inputs: Val_MasterclassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마스터클래스`)
};

/**
* | output |
* | --- |
* | "Masterclass" |
*
* @param {Val_MasterclassInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_masterclass = /** @type {((inputs?: Val_MasterclassInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MasterclassInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_masterclass(inputs)
	if (locale === "es") return es_val_masterclass(inputs)
	if (locale === "fr") return fr_val_masterclass(inputs)
	if (locale === "de") return de_val_masterclass(inputs)
	if (locale === "ja") return ja_val_masterclass(inputs)
	if (locale === "zh") return zh_val_masterclass(inputs)
	if (locale === "ar") return ar_val_masterclass(inputs)
	if (locale === "id") return id_val_masterclass(inputs)
	if (locale === "it") return it_val_masterclass(inputs)
	if (locale === "ru") return ru_val_masterclass(inputs)
	if (locale === "pt") return pt_val_masterclass(inputs)
	return ko_val_masterclass(inputs)
});